export default __webpack_public_path__ + "static/media/386.76023cb4.png";